import { FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { FormattedOpeningHour } from '../../utils/formatOpeningHours'

export type OpeningHourProps = FormattedOpeningHour

export const OpeningHour: FC<OpeningHourProps> = ({ days, hours, is_closed: isClosed }) => {
  const { formatMessage } = useIntl()
  return (
    <FormattedMessage
      id="general.opening_hour"
      defaultMessage="{days} {hours}"
      values={{
        days,
        hours: isClosed ? formatMessage({ id: 'general.closed' }) : hours,
      }}
    />
  )
}

export default OpeningHour
